"use client";

import { useLocalStorageState } from "@packages/sdk";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export type ClientRedirectProps = {
  currentTranslation?: string;
};

export const BibleRedirect = ({ currentTranslation }: ClientRedirectProps) => {
  const [category] = useLocalStorageState({
    key: "bibleCategory",
    defaultValue: "daily-readings",
  });
  const [translation] = useLocalStorageState({
    key: "bibleTranslation",
    defaultValue: "NRSV",
  });
  const [lastPage] = useLocalStorageState({
    key: "biblePage",
    defaultValue: "Gen/1",
  });
  const router = useRouter();

  useEffect(() => {
    if (router && category && lastPage && translation) {
      if (category === "daily-readings") {
        router.replace("/bible/daily-readings");
      } else if (lastPage && (translation || currentTranslation)) {
        router.replace(
          `/bible/${currentTranslation ?? translation}/${lastPage}`,
        );
      }
    }
  }, [router, category, lastPage, translation, currentTranslation]);

  return null;
};
